import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  buildingFacilityList: [],
  companyAccessPointList: [],
  companyAccessGroupList: [],
  accessCounts: {}
};

const facilitySlice = createSlice({
  name: "facilitySlice",
  initialState,
  reducers: {
    buildingFacilityListAction: (state, action) => {
      state.buildingFacilityList = [
        ...state.buildingFacilityList,
        ...action.payload.buildingFacilityList,
      ];
    },
    companyAccessPointAction: (state, action) => {
      state.companyAccessPointList = action.payload.companyAccessPointList;
    },
    companyAccessGroupAction: (state, action) => {
      state.companyAccessGroupList = action.payload.companyAccessGroupList;
    },
    companyAccessGroupDetailAction: (state, action) => {
      state.companyAccessGroupDetail = action.payload.companyAccessGroupDetail;
    },
    accessCountsAction: (state, action) => {
      state.accessCounts = action.payload.accessCounts;
    },
    resetFacilityStatesAction: (state, action) => {
      state.companyAccessPointList = [];
      state.companyAccessGroupList = [];
      state.companyAccessGroupDetail = [];
      state.accessCounts = {};
    }
  },
});

export const {
  buildingFacilityListAction,
  companyAccessPointAction,
  companyAccessGroupAction,
  companyAccessGroupDetailAction,
  accessCountsAction,
  resetFacilityStatesAction
} = facilitySlice.actions;

export default facilitySlice.reducer;
